import { GridsterItemConfig } from "angular-gridster2";
import { ICustomComponent } from "../interfaces/ICustomComponent.interface";
import { CustomComponentDTO } from "../dto/component/customComponent.dto";
import { Type } from "@angular/core";
import { ComponentRegistryService } from "../services/component-registry/component-registry.service";

export class CustomComponent implements GridsterItemConfig, ICustomComponent {
  name: string;
  uuid?: string;
  x: number;
  y: number;
  cols: number;
  rows: number;
  customCSS: string;
  settings: { [key: string]: { type: string, value: any } };
  //inputs: { [key: string]: { type: string, value: any } };
  mode: 1 | 2 | 3;
  component: Type<any> | null = null;
  componentInstance: any | null = null;
  parentUUID?: string;

  public inputs: { [key: string]: { type: string, value: any, options?: string[], displayText?: string, description?: string } } = {};

  dataSourceKey?: string;

  childComponents?: CustomComponent[];

  editorMode: boolean = false;

  constructor(
    name: string,
    x: number, 
    y: number, 
    cols: number, 
    rows: number, 
    customCSS: string, 
    settings: { [key: string]: { type: string, value: any } },
    inputs: { [key: string]: { type: string, value: any } },
    mode: 1 | 2 | 3,
    uuid?: string,
    childComponents?: CustomComponent[]
  ) {
    this.name = name;
    this.uuid = uuid || crypto.randomUUID();
    this.x = x;
    this.y = y;
    this.cols = cols;
    this.rows = rows;
    this.customCSS = customCSS;
    this.settings = settings || {};
    this.inputs = inputs || {};
    
    // Ensure autoHeight property is initialized to true by default
    if (!this.inputs['autoHeight']) {
      this.inputs['autoHeight'] = {
        type: 'boolean',
        value: true
      };
    }
    
    this.mode = mode;
    if (!this.settings['customID'] || !this.settings['customID'].value || this.settings['customID'].value.trim() === '') {
      this.settings['customID'] = { type: 'string', value: `${name}_${this.uuid}_parent` };
    }
    if (!this.settings['customClasses'] || !this.settings['customClasses'].value || this.settings['customClasses'].value.trim() === '') {
      this.settings['customClasses'] = { type: 'string', value: "" };
    }
    if (this.settings['fullBleed'] === undefined || this.settings['fullBleed'] === null) {
      // DynamicTabsComponent spans edge-to-edge by design — default to full-bleed.
      // All other components default to padded (false).
      const defaultFullBleed = name === 'DynamicTabsComponent';
      this.settings['fullBleed'] = { type: 'boolean', value: defaultFullBleed };
    }
    this.childComponents = childComponents;
  }

  public getOrSetInputs(): { [key: string]: { type: string, value: any, options?: string[], displayText?: string, description?: string } } {
    // Get the component instance's inputs if available
    let componentInputs: { [key: string]: { type: string, value: any, options?: string[], displayText?: string, description?: string } } = {};
    
    if (this.componentInstance) {
      // If the instance has inputs directly on it (from ComponentInputBase)
      if (this.componentInstance.inputs) {
        componentInputs = this.componentInstance.inputs;
      }
      // Also check for dynamicInput setter
      if (this.componentInstance.dynamicInput) {
        componentInputs = { ...componentInputs, ...this.componentInstance.dynamicInput };
      }
    }

    // Merge with existing inputs, letting existing values take precedence
    const mergedInputs = { ...componentInputs, ...this.inputs };
    
    // Ensure autoHeight property is always present and defaults to true
    if (!mergedInputs['autoHeight']) {
      mergedInputs['autoHeight'] = {
        type: 'boolean',
        value: true
      };
    }
    
    // Update the stored inputs
    this.inputs = mergedInputs;
    
    return mergedInputs;
  }

  configure(settings: any): void {
    this.settings = settings;
  }

  public generateUUID() {
    this.uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  public getComponent(registryService: ComponentRegistryService): Type<any> | null {
    if (!this.component) {
      const customComponent = registryService.getComponentByName(this.name);
      if (customComponent) {
        this.component = customComponent.component; // This will trigger the setter
      }
    }
    return this.component;
  }

  /*public setComponent(registryService: ComponentRegistryService){
    if (!this.component) {
      const customComponent = registryService.getComponentByName(this.name);
      if (customComponent) {
        if (customComponent.component && 'dyn_inputs' in customComponent.component) {
          customComponent.component.inputs = this.inputs;
        }
        this.component = customComponent.component;
      }
    }
  }*/

  public static convertToDTO(component: CustomComponent): CustomComponentDTO {
    
    const dto = {
      uuid: component.uuid || '',
      name: component.name,
      x: component.x,
      y: component.y,
      cols: component.cols,
      rows: component.rows,
      customCSS: component.customCSS,
      settings: component.settings,
      inputs: component.inputs,
      mode: component.mode,
      childComponents: component.childComponents?.map(child => CustomComponent.convertToDTO(child)),
      parentUUID: component.parentUUID
    };
    
    
    return dto;
  }

  public static fromDTO(dto: CustomComponentDTO): CustomComponent {
    // Ensure inputs has autoHeight property initialized to true by default
    const inputs = dto.inputs || {};
    if (!inputs['autoHeight']) {
      inputs['autoHeight'] = {
        type: 'boolean',
        value: true
      };
    }
    
    const component = new CustomComponent(
      dto.name,
      dto.x,
      dto.y,
      dto.cols,
      dto.rows,
      dto.customCSS,
      dto.settings,
      inputs,
      dto.mode,
      dto.uuid,
      dto.childComponents?.map(childDTO => CustomComponent.fromDTO(childDTO)) || []
    );
    
    return component;
  }
}
